import view from 'redux/view/reducers'
import misc from 'redux/misc/reducers'
import models from 'redux/models/reducers'


export default {
  view,
  misc,
  models,
}
